import React from 'react';
import { motion } from 'framer-motion';
import { CertificateValidation } from '../components/CertificateValidation';

export const CertificateValidationPage = () => {
  return (
    <div className="pt-20">
      {/* Page Header */}
      <section className="py-16 bg-gradient-to-br from-blue-600 to-blue-700 text-white">
        <div className="container mx-auto px-4">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center space-y-4"
          >
            <h1 className="text-5xl lg:text-6xl font-bold">
              Certificate Validation
            </h1>
            <p className="text-xl text-blue-100 max-w-3xl mx-auto">
              Verify the authenticity of ISDE Academy certificates
            </p>
          </motion.div>
        </div>
      </section>

      <CertificateValidation />
    </div>
  );
};
